export default "__VITE_ASSET__DwX$JWoD__"